<template>
  <div class="search-view" :key="componentKey">
    <v-container class="parts-container pa-0 ma-0"  fluid>
      <v-card class="d-flex align-content-start flex-wrap" flat color="transparent" tile>
        <v-data-table
          :headers="[ {'text' : project.uxd.labelsrbook, 'class' : 'searchresultsheader'},
                      {'text' : project.uxd.labelsrdrawing, 'class' : 'searchresultsheader'  },
                      {'text' : project.uxd.labelsrmatch, 'class' : 'searchresultsheader'  },
                      {'text' : project.uxd.labelsrpos, 'class' : 'searchresultsheader'},
                      {'text' : '', 'value' : ''}
                      ]"
          :items="project.searchResults"
          :no-data-text="project.searchLoading ? project.uxd.searching : project.uxd.nosearchresults"
          :disable-sort="true"
          :footer-props="{ 'items-per-page-text' : project.uxd.labelsrrowsperpage,
                            'items-per-page-all-text' : project.uxd.labelsrall,
                            'page-text' : project.uxd.labelsrpage
                        }"
          @pagination="pagenationChanged"
          style="width:100%"
          class="theme-fontname">

          <template v-slot:item="row">
            <tr class="theme-fontname">
              <td>{{row.item.pn}}</td>
              <td>{{row.item.dn}}</td>
              <td>{{row.item.v}}</td>
              <td>{{row.item.pos}}</td>
              <td>
                  <v-btn class="mx-2 theme-tabbackcolor" fab dark small @click="hideSearchAndShowDrawing(row.item)">
                      <v-icon dark>mdi-arrow-right-bold</v-icon>
                  </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </div>
</template>

<script>
  import {mapActions, mapGetters, mapState} from 'vuex'

  export default {
    name: 'SearchResult',
    data () {
      return {
        size: 3,
        msg: '',
        componentKey: 0
      }
    },
    computed: {
      ...mapState([
        'project',
        'session'
      ]),
      ...mapGetters([
        'isPartSelected',
        'parentPartId',
        'selectedPartId',
        'selectedDrawingId',
        'isPartListVisible',
        'isDrawingListVisible',
        'isDrawingVisible',

      ])
    },
    methods: {
      ...mapActions([
        'getPubTree',
        'selectPart',
        'showDrawing',
        'selectDrawingById',
        'showDrawingById',
        'search',
        'clearSearch',
        'navigateAfterSearch'
      ]),
      async hideSearchAndShowDrawing (searchResult) {
        this.navigateAfterSearch(searchResult);
      },
      pagenationChanged(val) {
        if(this.componentKey != val.itemsLength) {
          this.componentKey = val.itemsLength;    // Forces refresh
        }
      }
    }
  }
</script>

<style scoped>

  h1, h2 {
    font-weight: normal;
  }

</style>
